import { useEffect, useState } from "react";
import { api, type MenuProduct, type PointMenu } from "../api";
import { measure, money, Photo, Spinner } from "../ui";

/**
 * Меню одного заведения (п. 6 ТЗ).
 *
 * Недоступное блюдо остаётся в списке приглушённым, а не исчезает: гость
 * листал это меню полчаса назад и должен видеть, что блюдо есть, но
 * закончилось, — иначе он решит, что ошибся заведением.
 */
export function Menu({
  pointId,
  onPick
}: {
  pointId: string;
  onPick: (product: MenuProduct, point: { id: string; name: string }) => void;
}) {
  const [menu, setMenu] = useState<PointMenu | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setMenu(null);
    api
      .pointMenu(pointId)
      .then(setMenu)
      .catch((problem: Error) => setError(problem.message));
  }, [pointId]);

  if (error) {
    return (
      <div className="center">
        <p className="notice">{error}</p>
      </div>
    );
  }

  if (!menu) return <Spinner text="Открываем меню" />;

  const point = { id: menu.pointId, name: menu.pointName };

  return (
    <div className="page">
      {menu.categories.length === 0 ? (
        <p className="empty">Здесь пока пусто.</p>
      ) : (
        menu.categories.map(category => (
          <section key={category.id} className="category">
            <div className="section-head">
              <h2>{category.title}</h2>
            </div>

            <div className="dishes">
              {category.products.map(product => (
                <button
                  key={product.id}
                  type="button"
                  className={`dish${product.available ? "" : " out"}`}
                  onClick={() => product.available && onPick(product, point)}
                  disabled={!product.available}
                >
                  <Photo src={product.imageUrl} title={product.title} className="dish-photo" />

                  <span className="dish-body">
                    <span className="dish-title">{product.title}</span>
                    {product.description ? (
                      <span className="dish-note">{product.description}</span>
                    ) : null}

                    <span className="dish-foot">
                      <span className="price">{money(product.price)}</span>
                      {measure(product.weightG, product.volumeMl) ? (
                        <span className="measure">
                          {measure(product.weightG, product.volumeMl)}
                        </span>
                      ) : null}
                      {product.available ? null : <span className="badge">Закончилось</span>}
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
}
